import namespace from './namespace';

export default {
    [namespace.mutations.SET_CONFIGURATION] (state, responseData) {
        if (responseData !== undefined) {
            state[namespace.state.CONFIGURATION] = responseData;
            state[namespace.state.CONFIGURATION].Enabled = state[namespace.state.CONFIGURATION].IsEnabled;
        }
    },
    [namespace.mutations.DISABLE_VIEW] (state, loadingMessage) {
        state[namespace.state.WAITING_FOR_RESPONSE] = true;
        state[namespace.state.LOADING_MESSAGE] = loadingMessage;
    },
    [namespace.mutations.ENABLE_VIEW] (state) {
        state[namespace.state.WAITING_FOR_RESPONSE] = false;
    },
    [namespace.mutations.SET_VIEW_NOTIFICATION] (state, notification) {
        state[namespace.state.VIEW_NOTIFICATION] = notification;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/smtp/mutations.js